/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseCancellation
 */
export interface GetConfig200ResponseCancellation {
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseCancellation
     */
    time: number;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCancellation
     */
    unit: GetConfig200ResponseCancellationUnitEnum;
}


/**
 * @export
 */
export const GetConfig200ResponseCancellationUnitEnum = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days'
} as const;
export type GetConfig200ResponseCancellationUnitEnum = typeof GetConfig200ResponseCancellationUnitEnum[keyof typeof GetConfig200ResponseCancellationUnitEnum];


/**
 * Check if a given object implements the GetConfig200ResponseCancellation interface.
 */
export function instanceOfGetConfig200ResponseCancellation(value: object): value is GetConfig200ResponseCancellation {
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseCancellationFromJSON(json: any): GetConfig200ResponseCancellation {
    return GetConfig200ResponseCancellationFromJSONTyped(json, false);
}

export function GetConfig200ResponseCancellationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseCancellation {
    if (json == null) {
        return json;
    }
    return {
        
        'time': json['time'],
        'unit': json['unit'],
    };
}

export function GetConfig200ResponseCancellationToJSON(json: any): GetConfig200ResponseCancellation {
    return GetConfig200ResponseCancellationToJSONTyped(json, false);
}

export function GetConfig200ResponseCancellationToJSONTyped(value?: GetConfig200ResponseCancellation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'time': value['time'],
        'unit': value['unit'],
    };
}

